module.exports = ".close {\n    opacity: 1;\n}\n\n.menu.open .menu-circle {\n    -webkit-box-shadow: none;\n            box-shadow: none;\n}\n\n.loc-small {\n    top: -42px;\n}\n\n.loc-small h2 {\n    font-size: 19px;\n    margin: 0px 0px 5px 0px;\n}\n\n.menu.open .menu-icon {\n    width: 45px;\n    height: 45px;\n}\n\n.cooperativelabel {\n    width: 346px;\n    left: -86px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/menu/menu.component.css
// module id = ./src/app/menu/menu.component.css
// module chunks = main